<p-floatlabel>
    <p-autocomplete #serviceAutocomplete
        [(ngModel)]="selectedService" 
        [suggestions]="services"
        [showClear]="true"
        [forceSelection]="true"
        styleClass="w-100"
        inputStyleClass="form-control"
        [minLength]="MinAutocompleteCharsToSearch"
        (completeMethod)="loadServices($event)"
        (onSelect)="onChangeSelectedService()"
        (onClear)="onChangeSelectedService()"
        optionLabel="name"
        [emptyMessage]="l('::NoData')"
        inputId="label">
        <ng-template let-item pTemplate="item">
            <div>{{ item.name }}</div>
        </ng-template>
    </p-autocomplete>
    <label for="serviceAutocomplete">
        <app-label-content [isRequired]="isRequired">
            {{  l('::Service') }}
        </app-label-content>
    </label>
</p-floatlabel>